import { useGetInitialUserQuery } from 'gqlTypes'

type QueryParameters = Parameters<typeof useGetInitialUserQuery>[0]

const useUserProfile = (cacheOnly = true, hookOptions?: QueryParameters) =>
  useGetInitialUserQuery({
    ...hookOptions,
    fetchPolicy: cacheOnly ? 'cache-only' : 'cache-and-network',
  })

export default useUserProfile
